<template>
  <div>
    <div class="w-100 d-inline-block pets-service-bg-image padding-bottom-3 position-relative">
      <div class="container autoContent">
        <div class="row g-4 align-items-start margin-top-4">
          <!-- Left Column: Header + Best Services -->
          <div class="col-xl-6 col-lg-6 col-12">
            <div class="services-header mb-4">
              <span class="txt-gray fw-bold text-size-14 family-filson-bold text-uppercase">Our Services</span>
              <h2 class="text-black fw-bold family-filson-bold mt-1 text-size-36 text-full-24">
                {{ serviceHeading }}
              </h2>
              <p class="text-size-15 text-black mb-0 family-inter-light text-full-13">
                {{ serviceContent }}
              </p>
            </div>

            <div class="best-services-card rounded-4 p-2 shadow-sm position-relative">
              <div class="row">
                <div class="col-xl-8 col-lg-8 col-12 pe-0">
                  <span class="txt-blue fw-bold text-size-14 text-uppercase family-filson-bold">We love our job!</span>
                  <h3 class="text-black fw-bold family-filson-bold mt-1 text-size-22 text-full-14 mb-2">
                    {{ lovejobHeading }}
                  </h3>
                  <p class="text-size-14 text-black mb-2 family-inter-light lh-base text-full-12">
                    {{ lovejobContent }}
                  </p>

                  <!-- 3x3 Features Grid -->
                  <div class="row g-2 features-grid">
                    <div class="col-4" v-for="(feature, index) in features" :key="index">
                      <div class="feature-item d-flex align-items-center">
                        <img :src="feature.icon" :alt="feature.label" class="feature-icon me-2">
                        <span class="text-black text-size-11 family-filson-medium lh-sm">{{ feature.label }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Sidebar Info Cards -->
                <div class="col-xl-4 col-lg-4 col-12 mt-lg-0 mt-4">
                  <div class="d-flex flex-column gap-2 h-100 justify-content-center">
                    <div class="info-tag bg-white rounded-3 p-2 shadow-sm d-flex align-items-center" v-for="(tag, index) in infoTags" :key="index">
                      <div class="info-icon-bg rounded-circle d-flex align-items-center justify-content-center me-2">
                        <img :src="tag.icon" :alt="tag.title" class="info-icon">
                      </div>
                      <div>
                        <p class="mb-0 text-size-11 fw-bold text-black family-filson-bold text-uppercase lh-1">{{ tag.title }}</p>
                        <p class="mb-0 text-size-9 text-black opacity-50">{{ tag.desc }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Column: Pet Service Grid (2x2) -->
          <div class="col-xl-6 col-lg-6 col-12">
            <div class="row g-3">
              <div class="col-12 col-md-6 col-lg-6" v-for="(service, index) in petServicesForDisplay" :key="index">
                <div class="pet-service-card rounded-4 bg-light-gray h-100 overflow-hidden">
                  <div class="row align-items-center h-100 g-0">
                    <div class="col-6 h-100">
                      <div class="pet-img-wrapper h-100 d-flex align-items-end justify-content-center">
                        <img :src="service.image" :alt="service.title" class="pet-card-img">
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="pet-content p-3 ps-0">
                        <h4 class="text-black fw-bold text-size-15 family-filson-bold mb-1 text-uppercase text-full-13">{{ service.title }}</h4>
                        <p class="text-black text-size-12 mb-2 family-inter-light lh-sm text-full-11">{{ service.desc }}</p>
                        <router-link :to="service.link" class="txt-orange text-size-13 fw-bold text-decoration-none family-inter-bold text-full-11">
                          Book Now <i class="fa fa-arrow-right ms-1"></i>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { withCountryPath } from '@/utils/countryPath';

export default {
  name: "ourServicesComponent",
  data() {
    return {
      features: [
        { label: 'Haircuts And Styling', icon: require('@/assets/images/cut-service-icon-image.svg') },
        { label: 'Face, Ear, Eye Cleaning', icon: require('@/assets/images/cut-service-icon-image-2.svg') },
        { label: 'Nail Trimming and clipping', icon: require('@/assets/images/cut-service-icon-image-3.svg') },
        { label: 'Shower shampoo and Conditioner', icon: require('@/assets/images/cut-service-icon-image-4.svg') },
        { label: 'Paw Trim', icon: require('@/assets/images/cut-service-icon-image-5.svg') },
        { label: 'Perfumed Spray & Anti Powder', icon: require('@/assets/images/cut-service-icon-image-6.svg') },
        { label: 'Blow Drying & Flat Brushbrush', icon: require('@/assets/images/cut-service-icon-image-7.svg') },
        { label: 'Tooth Brushing & Oral Clean Care', icon: require('@/assets/images/cut-service-icon-image-8.svg') },
        { label: 'Anal Gland Expression', icon: require('@/assets/images/cut-service-icon-image-9.svg') },
      ],
      infoTags: [
        { title: 'We Love Every Pet', desc: 'We love every pet, so your pet feel relaxed and stress free.', icon: require('@/assets/images/every-pet-icon.svg') },
        { title: 'Top Groomers', desc: 'The grooming service provided by our qualified staff is remarkable.', icon: require('@/assets/images/top-groom-icon.svg') },
        { title: 'V.I.P Service', desc: 'We take pride in giving you and your pet personalized attention.', icon: require('@/assets/images/vip-service-icon.svg') },
      ],
      defaultPetServices: [
        { title: 'Dogs Grooming', desc: 'Trust us with your doggy, and we will groom it with perfection.', image: require('@/assets/images/dog-grooming-service.png'), link: '/services/mobile-dog-grooming-dubai-pet-groomer/' },
        { title: 'Cats Grooming', desc: 'A well-groomed cat means a happy cat, and a happy cat means happy you.', image: require('@/assets/images/cat-grooming-service.png'), link: '/services/mobile-cat-grooming-service-dubai/' },
        { title: 'Birds Grooming', desc: 'We keep your furry partners happy, clean, and groomed.', image: require('@/assets/images/birds-grooming-service.png'), link: '/services/bird-grooming-services-dubai-pet-groomer/' },
        { title: 'Rabbits Grooming', desc: 'All it takes is a little trimming and a bath for a picture-perfect pet.', image: require('@/assets/images/rabbit-grooming-rabbit-groomer-mobile-rabbit-grooming.png'), link: '/services/rabbit-grooming-dubai-mobile-pet-groomer/' },
      ],
      serviceHeading: 'Professional mobile pet grooming',
      serviceContent:
        'Lush Groom stands proudly behind its vision of making pet grooming comprehensive, affordable, and accessible to all so that your pets live healthy and happy lives.',
      lovejobHeading: "We Provide Best Services For Your Pet's",
      lovejobContent:
        'Lush Groom stands proudly behind its vision of making pet grooming comprehensive, affordable, and accessible to all so that your pets live healthy and happy lives.',
      petServices: [],
    };
  },
  computed: {
    petServicesForDisplay() {
      const src = this.petServices && this.petServices.length ? this.petServices : this.defaultPetServices;
      return src.map((p) => ({ ...p, link: withCountryPath(p.link) }));
    },
  },
  methods: {
    async fetchHomePageText() {
      try {
        const res = await this.$axios.post('/get-home-page', {
          website_name: this.activeWebsiteName,
        });
        const page = res?.data?.home_page;
        if (!page) return;
        this.serviceHeading = page.service_heading || this.serviceHeading;
        this.serviceContent = page.service_content || this.serviceContent;
        this.lovejobHeading = page.lovejob_heading || this.lovejobHeading;
        this.lovejobContent = page.lovejob_content || this.lovejobContent;
      } catch (e) {
        console.error('fetchHomePageText', e);
      }
    },
    async fetchWebsiteCategoriesForServices() {
      try {
        const form = new URLSearchParams();
        form.append('website_name', this.activeWebsiteName || '');
        const res = await this.$axios.post('/get-categories-home', form);
        if (res?.data?.status === 'success' && Array.isArray(res.data.categories)) {
          const mapped = res.data.categories
            .filter((c) => c && c.status !== '0')
            .slice(0, 4)
            .map((c) => ({
              title: c.name,
              desc: c.description || '',
              image: c.image ? this.$getImageUrl(c.image) : '',
              link: c.slug ? `/services/${c.slug}/` : '/services/',
            }));

          this.petServices = mapped.length ? mapped : this.defaultPetServices;
        } else {
          this.petServices = this.defaultPetServices;
        }
      } catch (e) {
        this.petServices = this.defaultPetServices;
      }
    },
  },
  mounted() {
    this.petServices = this.defaultPetServices;
    this.fetchHomePageText();
    this.fetchWebsiteCategoriesForServices();
  },
  watch: {
    activeWebsiteName() {
      this.fetchHomePageText();
      this.fetchWebsiteCategoriesForServices();
    },
  },
};
</script>

<style scoped>
.best-services-card {
  background-color: #FFFAF4;
}

.bg-light-gray {
  background-color: #F2F2F2 !important;
}

.feature-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.info-icon-bg {
  width: 35px;
  height: 35px;
  background-color: #FFF2E6;
  flex-shrink: 0;
}

.info-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.pet-card-img {
  max-width: 100%;
  height: 130px;
  object-fit: contain;
  margin-bottom: 30px; /* Slight overlap to ensure it touches bottom */
}

.pet-service-card {
  transition: transform 0.3s ease;
}

.pet-service-card:hover {
  transform: translateY(-5px);
}

.border-end-sm {
  border-right: 1px solid #E0E0E0;
}

@media (max-width: 991.98px) {
  .border-end-sm {
    border-right: none;
    border-bottom: 1px solid #E0E0E0;
    padding-bottom: 2rem;
    margin-bottom: 2rem;
  }
}

.lh-lg { line-height: 1.8; }
.text-size-36 { font-size: 36px; }
.text-size-22 { font-size: 22px; }
.text-size-15 { font-size: 15px; }
.text-size-11 { font-size: 11px; }
.text-size-9 { font-size: 9px; }

.txt-orange {
  color: #fd7e14 !important;
}
.txt-blue {
  color: #11487B !important;
}
.txt-gray {
  color: #7E7E7E !important;
}
.info-tag{
  border: 1px solid #9F9F9F;
}
</style>
